import React from "react";
import { compact } from "lodash";
import Group from "@material-ui/icons/Group";
import FaceIcon from "@material-ui/icons/Face";
import WorkIcon from "@material-ui/icons/Work";
import Bookmark from "@material-ui/icons/Bookmark";
import { EventLog_CustomerEventFragment } from "@graphql";
import { ChipArray } from "@components/ChipArray";
import { InlineEditor } from "@components/InlineEditor/InlineEditor";
import { CustomerEventFloatingMenu } from "../CustomerEventFloatingMenu/CustomerEventFloatingMenu";
import { Event } from "../../Event/Event";
import { CustomerEventLogStore } from "../CustomerEventLogStore";
import { Body, PlainLink } from "@common";
import locale from "@bonliva-crm/locale";
import { StyledHtml } from "@common/StyledHtml";

type Props = {
  item: EventLog_CustomerEventFragment;
  store: CustomerEventLogStore;
};

type State = {
  isEditing: boolean;
};

export class CustomerEvent extends React.Component<Props, State> {
  state: State = {
    isEditing: false
  };

  startEdit = () => this.setState({ isEditing: true });
  finishEdit = () => this.setState({ isEditing: false });

  update = (desc: string) => {
    const { item, store } = this.props;
    return store.updateEvent(item._id, desc).then(this.finishEdit);
  };

  renderChips = () => {
    const { item } = this.props;

    const areasOfExp = item.AreasOfExpertise.map((a) => ({
      label: a,
      key: a,
      icon: <WorkIcon />
    }));

    const contactPersons = item.ContactPerson.map((c) => ({
      label: c.Name,
      key: c.NodeID,
      icon: <FaceIcon />
    }));

    const roles = Array.isArray(item.Roles)
      ? item.Roles.map((r) => ({
          label: r,
          key: r,
          icon: <Group />
        }))
      : [];

    const customerGroup = item.CustomerGroup
      ? {
          label: item.CustomerGroup,
          key: item.CustomerGroup,
          icon: <Bookmark />
        }
      : null;

    return (
      <ChipArray
        items={compact([...areasOfExp, ...contactPersons, ...roles, customerGroup])}
        style={{ paddingLeft: 0 }}
      />
    );
  };

  render() {
    const { item, store } = this.props;
    const { isEditing } = this.state;

    const menu = (
      <CustomerEventFloatingMenu
        event={item}
        onEdit={this.startEdit}
        onDelete={() => store.deleteEvent(item._id)}
      />
    );

    return (
      <Event key={this.props.item._id} item={item} floatingMenu={menu}>
        <>
          {this.renderChips()}

          <InlineEditor
            readOnlyRenderer={() => <StyledHtml>{item.DescriptionHtml}</StyledHtml>}
            initialValue={item.Description}
            onSubmit={this.update}
            isEditing={isEditing}
            onCancel={this.finishEdit}
          />

          {item.MetBy && (
            <Body>
              {locale.CustomerMetBy}{" "}
              <PlainLink dashed inline onClick={() => alert("not implemented")}>
                {item.MetBy.Name}
              </PlainLink>
            </Body>
          )}
        </>
      </Event>
    );
  }
}

export default CustomerEvent;
